import { render, staticRenderFns } from "./PostBar.vue?vue&type=template&id=489d7b16&scoped=true"
import script from "./PostBar.vue?vue&type=script&lang=js"
export * from "./PostBar.vue?vue&type=script&lang=js"
import style0 from "./PostBar.vue?vue&type=style&index=0&id=489d7b16&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489d7b16",
  null
  
)

export default component.exports